module.exports = __webpack_public_path__ + "h5/img/open.97b368c2.gif";